<template>
  <x-page title="搜索" :loading="loading" :white-background="true">
    <div :class="_.page">
      <!-- 搜索栏 -->
      <x-goods-search-bar
        v-model="keyword"
        :default-keyword="defaultKeyword"
        :query-keywords="getQueryKeywords"
        @confirm="handleSearchConfirm"
      />

      <!-- 历史搜索 -->
      <div v-if="historyData.length" :class="_.record">
        <div :class="_.hd">
          <div :class="_.title">历史搜索</div>
          <div
            v-track="{
              name: '清空',
              id: 'clexmlsb7000mvprle6xd034v',
            }"
            :class="_.action"
            @click="handleClearHistoryClick"
          >
            <x-icon name="remove" :class="_.icon" />
            <div :class="_.text">清空</div>
          </div>
        </div>
        <div :class="_.bd">
          <div
            v-for="item in historyData"
            :key="item"
            :class="[_.item, _._ellipsis]"
            @click="handleSearchConfirm(item, '历史搜索')"
          >
            {{ item }}
          </div>
        </div>
      </div>

      <!-- 热门搜索 -->
      <div v-if="hotData.length" :class="_.record">
        <div :class="_.hd">
          <div :class="_.title">热门搜索</div>
        </div>
        <div :class="_.bd">
          <div
            v-for="item in hotData"
            :key="item.id"
            :class="[_.item, _._ellipsis]"
            @click="handleSearchConfirm(item.title, '热门搜索')"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiPageConfigGetStateContent,
    apiSearchMartSearchSearchKeyword,
  } from '@/api'
  import { currentChannelId } from '@/channel'
  import { historyModel } from './model'
  import { mapQuery, prepareData, Track } from '@/utils'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    mixins: [
      mapQuery({
        // 关键词
        q: {
          key: 'q',
          default: undefined,
        },
        // 场景 ID
        s: {
          key: 's',
          default: '55f9be7e73c04949bfa7a0c850d33924',
        },
        // 关联类目
        l: {
          key: 'l',
          json: true,
          default: [],
        },
      }),
      Track.provideMark(() => ({
        page: '搜索',
      })),
    ],

    data: () => ({
      loading: true,
      historyData: [],
      hotData: [],
      keyword: '',
      defaultKeyword: '',
    }),

    mounted() {
      this.prepareData()
    },

    activated() {
      this.refreshHistoryData()
    },

    methods: {
      async prepareData() {
        const { hotData } = await prepareData({
          hotData: apiPageConfigGetStateContent({
            stateId: '8aaa8b6279c70c8c0179d4b686740024',
            pageIndex: 1,
            pageSize: 20,
          }),
        })
        this.defaultKeyword = this.q
        this.hotData = hotData.list
        this.loading = false
      },
      async getQueryKeywords(keyword) {
        return apiSearchMartSearchSearchKeyword({
          keyword: keyword,
          refUserGroupId: currentChannelId,
        })
      },
      handleClearHistoryClick() {
        historyModel.clear()
        this.refreshHistoryData()
      },
      handleSearchConfirm(keyword, from) {
        this.$track.push({
          name: '搜索确定',
          id: 'clexmn5r1000ovprl8bsv2l4v',
          newId: 'SouSuo',
          content: keyword,
          extra: {
            search_scene_id: this.s,
            search_type: from,
            keyword: keyword,
          },
        })
        navigateTo('SearchIndex', {
          q: keyword,
          s: this.s,
          l: JSON.stringify(this.l),
        })
        historyModel.add(keyword)
        this.refreshHistoryData()
      },
      refreshHistoryData() {
        this.historyData = historyModel.get()
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    padding: 12px 12px 12px 12px;

    .record {
      margin-top: 28px;

      .hd {
        display: flex;
        align-items: center;

        .title {
          flex-grow: 1;
          font-size: 16px;
          font-weight: bold;
          color: #222222;
        }

        .action {
          flex-shrink: 0;
          display: flex;
          align-items: center;

          .icon {
            font-size: 14px;
            color: #888888;
          }

          .text {
            margin-left: 4px;
            font-size: 14px;
            color: #888888;
          }

          &:active {
            opacity: 0.9;
          }
        }
      }

      .bd {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .item {
          max-width: 60%;
          height: 28px;
          line-height: 28px;
          background: #f5f5f5;
          border-radius: 1000px;
          padding: 0 12px;
          white-space: nowrap;
          font-size: 14px;
          color: #888888;
          margin-right: 8px;
          margin-top: 12px;

          &:active {
            filter: contrast(0.9);
          }
        }
      }
    }
  }
</style>
